import React from "react";

const ALL_DIRECT_REPORTS = "All Direct Reports";

export default class PtoCalendarViewReportTree extends React.Component {
    constructor(props) {
        super(props);

        this.search = null;
        this.input = null;
        this._flatten = this._flatten.bind(this);
        this._onDropdownClicked = this._onDropdownClicked.bind(this);
        this._onDropdownBlur = this._onDropdownBlur.bind(this);
        this._onItemSelected = this._onItemSelected.bind(this);
        this._onKeyUp = this._onKeyUp.bind(this);
        this._onSearchClicked = this._onSearchClicked.bind(this);
        this._getHighlightedText = this._getHighlightedText.bind(this);

        this.peopleList = this._flatten(props.staffTree);
        const selectedPeopleId = props.selectedPeopleId || 0;
        const selectedPeople = this.peopleList.find(p => p.peopleId === selectedPeopleId);

        this.state = {
            staffTree: props.staffTree,
            flatten: this.peopleList,
            selectedPeopleId: selectedPeopleId,
            selectedText: selectedPeopleId !== 0 && selectedPeople ? selectedPeople.fullName : ALL_DIRECT_REPORTS,
        };

    }

    _flatten(staffTree) {
        if (!staffTree) return [];
        const result = [];
        for (const staff of staffTree) {
            result.push(staff);
            var subs = this._flatten(staff.directReportingStaffs);
            for (const sub of subs) {
                result.push(sub);
            }
        }

        result.sort((l, r) => {
            const lfname = l.fullName.toLowerCase();
            const rfname = r.fullName.toLowerCase();
            return lfname < rfname ? -1 : lfname < rfname ? 1 : 0;
        });

        return result;

    }

    _onDropdownClicked(evt) {
        this.refs.dropdownMenu.classList.toggle('open');
        if (this.input.value.trim().length > 0)
            this.input.focus();
    }

    _onDropdownBlur(evt) {
        const self = this;

        setTimeout(function() {
            if (!self.refs.dropdownMenu.contains(document.activeElement))
                self.refs.dropdownMenu.classList.remove('open');
        }, 10);
    }

    _onItemSelected(peopleTO) {
        if (!peopleTO) {
            this.setState({
                selectedPeopleId: 0,
                selectedText: ALL_DIRECT_REPORTS
            });
            if (typeof this.props.onChange === "function") this.props.onChange(null);
        } else if (peopleTO.peopleId !== this.state.selectedPeopleId) {
            this.setState({
                selectedPeopleId: peopleTO.peopleId,
                selectedText: peopleTO.fullName
            });
            if (typeof this.props.onChange === "function") this.props.onChange(peopleTO);
        }

        this.refs.dropdownMenu.classList.remove('open');
        this.refs.dropdownButton.focus();
    }

    _onKeyUp(evt) {
        let value = evt.target.value.trim().toLowerCase();
        this.search.className = (value == "") ? 'fa fa-search' : 'fa fa-times-circle';

        let items = this.peopleList.filter(x => x.fullName.trim().toLowerCase().includes(value));
        this.setState({ flatten: items });
    }

    _onSearchClicked(evt) {
        const self = this;

        if (self.search.className.includes('fa-times-circle')) {
                self.search.className = 'fa fa-search';
                self.input.value = "";
                self.input.focus();
                self.setState({ flatten: self.peopleList });
        }
        else {
                self.search.className = 'fa fa-times-circle';
                self.input.focus();
        }
    }

    _voidAnchorClickHandler(evt) {
        evt.preventDefault();
        return false;
    }

    _getHighlightedText(text) {
        if (this.input == null || text == null)
            return text;

        var textToSearch = this.input.value.trim().toLowerCase();

        if (textToSearch != '') {
            text = text.replace(RegExp(textToSearch + "(?![^<>]*>)", "gi"), function(e) {
                return '<b>' + e + '</b>';
            });
        }
        
        return text;
    }

    render() {
        const self = this;
        const checkIconClass = "fa fa-check ap-horiz-margin-5";
        const blankIconClass = "fa fa-fw ap-horiz-margin-5";

        return (
            <div className="form-group-sm ap-horiz-margin-5">
                <div className="dropdown input-group input-group-sm ap-dropdown " ref="dropdownMenu">
                    <button ref="dropdownButton" aria-haspopup="true" aria-expanded="true" style={{ width: 200 }} 
                        onClick={this._onDropdownClicked} onBlur={this._onDropdownBlur}>
                        <div style={{ display: "flex", flexDirection: "row" }}>
                            <span className="dropdown-label">{this.state.selectedText}</span>
                            <span className="input-group-addon fa fa-caret-down ap-clickable ap-addon-button dropdown-toggler"></span>
                        </div>
                    </button>
                    <ul className="dropdown-menu ap-report-tree" aria-labelledby="dropdownText">
                        <li className="ap-px-1 ap-unwrap-content">
                            <div className="input-group">
                                <input type="text"
                                        className="input form-control"
                                        placeholder="Type staff's name"
                                        onKeyUp={this._onKeyUp}
                                        ref={ref => this.input = ref} />
                                <div className="input-group-addon ap-clickable" onClick={this._onSearchClicked}>
                                    <a className="fa fa-search" ref={ref => this.search = ref}  onClick={this._voidAnchorClickHandler} />
                                </div>
                            </div>
                        </li>
                        <li className="ap-clickable ap-px-1 ap-unwrap-content" onClick={() => this._onItemSelected(null)}>
                            <a href="#" onClick={this._voidAnchorClickHandler}><span className={this.state.selectedPeopleId === 0 ? checkIconClass : blankIconClass}></span><span>All Direct Reports</span></a>
                        </li>
                        {
                            this.state.flatten.map(p => (
                                <li key={p.peopleId} className="ap-clickable ap-px-1 ap-unwrap-content" onClick={() => this._onItemSelected(p)}>
                                    <a href="#" className="ap-unwrap-content" onClick={this._voidAnchorClickHandler}
                                        style={{ display: "flex", flexDirection: "row", width: "100%" }}>
                                        <span style={{ flexGrow: 0 }} className={this.state.selectedPeopleId === p.peopleId ? checkIconClass : blankIconClass}></span>
                                        <span style={{ flexGrow: 0, marginRight: 40 }} dangerouslySetInnerHTML={ { __html: self._getHighlightedText(p.fullName) } }></span>
                                        <span style={{ flexGrow: 1, textAlign: "right", color: "#999" }}>{p.directReportingStaffs && p.directReportingStaffs.length > 0 ? `${p.directReportingStaffs.length} Staff(s)` : ""}</span>
                                    </a>
                                </li>
                            ))
                        }
                    </ul>
                </div>
            </div >
        );
    }
}